var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalbackgroundWrap"},[_c('div',{staticClass:"modalbackground",on:{"click":function($event){return _vm.$emit('backgroundClose')}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }